function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f531b3b4-7269-4389-8134-d497689e746e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1037.54 805.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bea29bfb-e980-4d37-afea-e40198499114",
    "data-name": "Ipad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.93,733.92s17.58-14,58.83-14.26c12.79-.08,45.46,3.57,59.72,14.26l.89,32.09-123.9-2.67Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.36,694.21H791.13a18.92,18.92,0,0,0,18.71-16.08l46.53-326.68a18.92,18.92,0,0,0-18.71-21.76H276.89a18.91,18.91,0,0,0-18.71,16.08L211.65,672.44A18.93,18.93,0,0,0,230.36,694.21Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.13,696.71H230.36a21.42,21.42,0,0,1-21.18-24.65L255.7,345.42a21.31,21.31,0,0,1,21.19-18.23H837.66a21.42,21.42,0,0,1,21.18,24.64L812.32,678.48A21.32,21.32,0,0,1,791.13,696.71ZM276.89,332.19a16.33,16.33,0,0,0-16.24,13.95L214.12,672.79a16.43,16.43,0,0,0,16.24,18.92H791.13a16.33,16.33,0,0,0,16.24-14L853.9,351.1a16.43,16.43,0,0,0-16.24-18.91Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.14,673.7h534a18.91,18.91,0,0,0,18.71-16.08l46.53-306.17a18.92,18.92,0,0,0-18.7-21.76h-534A18.93,18.93,0,0,0,258,345.77L211.43,651.94A18.92,18.92,0,0,0,230.14,673.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.17,676.2h-534A21.41,21.41,0,0,1,209,651.56l46.53-306.17a21.29,21.29,0,0,1,21.18-18.2h534a21.43,21.43,0,0,1,21.18,24.64L785.36,658A21.31,21.31,0,0,1,764.17,676.2Zm-487.5-344a16.33,16.33,0,0,0-16.24,13.95L213.9,652.31a16.42,16.42,0,0,0,16.24,18.89h534a16.33,16.33,0,0,0,16.24-14l46.53-306.17a16.42,16.42,0,0,0-16.23-18.89Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,791.86s7-76,17.43-104.56,4.18-77.38-44.61-154.76c0,0,11.14-60.44-20.93-76.33a7.59,7.59,0,0,0-10.88,5.87L205,536s-22.31,16.73-14,45.31c0,0,21.61,75.29,12.55,114.32l-33.46,96.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,794.36H170.13a2.49,2.49,0,0,1-2.36-3.32L201.19,695c8.73-38-12.33-112.2-12.55-112.94-7.77-26.57,9.82-43.7,14-47.29l9.2-73a10.15,10.15,0,0,1,5.25-7.65,10,10,0,0,1,9.22-.15c31.48,15.6,23.81,69.8,22.44,78,53,84.31,53.37,131.44,44.34,156.14-10.23,27.94-17.22,103.17-17.29,103.93A2.5,2.5,0,0,1,273.3,794.36Zm-99.65-5H271c1.26-13.09,7.8-76.8,17.35-102.92,8.68-23.73,8-69.46-44.38-152.56a2.51,2.51,0,0,1-.34-1.79c.1-.59,10.43-58.77-19.58-73.64a5,5,0,0,0-4.63.08,5,5,0,0,0-2.66,3.86l-9.32,74a2.55,2.55,0,0,1-1,1.69c-.85.64-20.81,16.1-13.05,42.61.9,3.11,21.69,76.37,12.59,115.59a1.83,1.83,0,0,1-.08.25Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26,585.93a2.52,2.52,0,0,1-2.43-1.89,278.74,278.74,0,0,1-6.34-47.89,2.5,2.5,0,0,1,5-.25,272.32,272.32,0,0,0,6.21,46.93,2.51,2.51,0,0,1-1.82,3A2.6,2.6,0,0,1,211.26,585.93Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.41,554.63a58.34,58.34,0,0,1-34.2-11,145.1,145.1,0,0,1-32.64-33.43l8.31-5.55h0c.2.31,12.05,17.81,30.16,30.87s49.12,15.38,81.3-17.64c6.07-6.23,13.21-14.15,20.77-22.54,42.68-47.34,107.18-118.88,170.7-105,35.55,7.75,65.28,33.22,88.37,75.69,6.16,11.33,20.44,24.25,37.24,25.84,16.51,1.57,32.84-7.39,48.61-26.62,10.57-12.88,30.23-36.86,57.15-42.84l2.17,9.76c-23.55,5.23-41.1,26.63-51.59,39.42-22.44,27.35-43.54,31.54-57.28,30.24-20.56-1.95-37.46-17-45.09-31-21.64-39.81-49.13-63.6-81.71-70.7-57.85-12.62-120,56.33-161.14,102-7.63,8.46-14.84,16.45-21,22.82C369.42,546.53,348.49,554.63,330.41,554.63Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.48,734.37S190.19,757.1,225,758.88c58.78,3,70-24.51,70-24.51L300.27,803H158.54Z",
    style: {
      fill: "#2563f6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.63,
    y: 590.59,
    width: 70.42,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.96,
    y: 608.41,
    width: 115.88,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.17,
    y: 626.24,
    width: 115.88,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "b7e93ac0-195b-4524-9581-7e9cb4aaed7c",
    "data-name": "Chart"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 114.1,
    width: 349.03,
    height: 192.44,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,309.54H0V111.1H355Zm-349-6H349V117.1H6Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.11,269.13a57.76,57.76,0,0,1-26.9-6.65l4.67-8.84a47.7,47.7,0,0,0,69.82-39.25l10,.61A57.75,57.75,0,0,1,103.11,269.13Z",
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6,256.75a55.19,55.19,0,1,1,86.49-50l-5,.42a50.19,50.19,0,1,0-78.65,45.49Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.95,
    cy: 257.36,
    r: 8.23,
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.24,
    cy: 211.26,
    r: 8.23,
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,208.47l-10-.62a57.73,57.73,0,0,1,57.57-54.09h0a57.77,57.77,0,0,1,26.9,6.66l-4.68,8.84a47.73,47.73,0,0,0-22.22-5.5h0A47.72,47.72,0,0,0,200,208.47Z",
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.62,266.63h0a55.21,55.21,0,0,1-55-50.52l5-.42a50.47,50.47,0,0,0,50,45.94h0a50.19,50.19,0,0,0,28.67-91.38l2.86-4.1a55.19,55.19,0,0,1-31.53,100.48Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.8,
    cy: 165.54,
    r: 8.23,
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.49,
    cy: 211.6,
    r: 8.23,
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.13,
    y: 195.17,
    width: 31.46,
    height: 4,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.13,
    y: 210.9,
    width: 55.25,
    height: 4,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.74,
    y: 195.17,
    width: 31.46,
    height: 4,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.74,
    y: 210.9,
    width: 55.25,
    height: 4,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.2,407.68h-6l6,0Zm0-12h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6ZM388,213.81H376v-6h12Zm-24,0H352v-6h12Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.76,
    cy: 420.61,
    r: 15.15,
    style: {
      fill: "#2a69ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.76,438.26a17.66,17.66,0,1,1,17.65-17.65A17.67,17.67,0,0,1,394.76,438.26Zm0-30.31a12.66,12.66,0,1,0,12.65,12.66A12.68,12.68,0,0,0,394.76,408Z",
    style: {
      fill: "#2e2e76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "f2febb1f-7973-4b6c-9055-c27d1503e7c0",
    "data-name": "Chart"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 769.58,
    y: 148.29,
    width: 264.96,
    height: 147.08,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.54,298.37h-271V145.29h271Zm-265-6h259V151.29h-259Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 818.73,
    y: 173.6,
    width: 25.82,
    height: 99.08,
    style: {
      fill: "#2a69ea"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 912.48,
    y: 173.6,
    width: 25.82,
    height: 99.08,
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 865.89,
    y: 209.25,
    width: 25.82,
    height: 63.43,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 959.63,
    y: 241.25,
    width: 25.82,
    height: 31.72,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 800.63,
    y: 270.4,
    width: 201.53,
    height: 4,
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.43,398.14h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6v-12h6Zm0-24h-6V219.28h7.15v6h-1.15Zm49.15-4.86h-12v-6h12Zm-24,0h-12v-6h12Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 717.43,
    cy: 409.02,
    r: 15.15,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.43,426.67A17.65,17.65,0,1,1,735.09,409,17.67,17.67,0,0,1,717.43,426.67Zm0-30.3A12.65,12.65,0,1,0,730.09,409,12.66,12.66,0,0,0,717.43,396.37Z",
    style: {
      fill: "#2e2e76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "a8d1af22-ab72-443c-9286-49ca3207dbf2",
    "data-name": "Chart"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 409.02,
    y: 3,
    width: 275.31,
    height: 153.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.33,159.76H406V0H687.33Zm-275.31-6H681.33V6H412Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.22,61.52a45.84,45.84,0,0,0-39.28-25l-1.48,0a45.75,45.75,0,0,0-42.33,63.18c.23.56.47,1.12.72,1.66a46,46,0,0,0,21.8,22.18,45.75,45.75,0,0,0,60.57-62Zm-40.76,54.2a33.16,33.16,0,0,1-15-3.56,33.61,33.61,0,0,1-15.54-16.31q-.32-.7-.6-1.44a33,33,0,0,1-2.27-12.09,33.44,33.44,0,0,1,33.41-33.4c.49,0,1,0,1.48,0a33.4,33.4,0,0,1-1.48,66.77Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.94,36.57V49c-.49,0-1,0-1.49,0a33.39,33.39,0,0,0-30.53,46.93l-11.07,5.54a45.76,45.76,0,0,1,41.6-64.84Z",
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.22,61.52,512,68.72a33.45,33.45,0,0,0-30.51-19.8V36.55A45.83,45.83,0,0,1,522.22,61.52Z",
    style: {
      fill: "#2a69ea"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 574.98,
    cy: 55.72,
    r: 6.93,
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.26,
    y: 52.51,
    width: 59.88,
    height: 6.43,
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.83,576.76h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Zm0-24h-5v-12h5Z",
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 574.98,
    cy: 78.48,
    r: 6.93,
    style: {
      fill: "#2a69ea"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.26,
    y: 75.27,
    width: 59.88,
    height: 6.43,
    style: {
      fill: "#2a69ea"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 574.98,
    cy: 101.25,
    r: 6.93,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.26,
    y: 98.03,
    width: 59.88,
    height: 6.43,
    style: {
      fill: "#f5b3a5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 546.29,
    cy: 589.97,
    r: 15.15,
    style: {
      fill: "#89efd7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.29,607.62A17.66,17.66,0,1,1,563.94,590,17.67,17.67,0,0,1,546.29,607.62Zm0-30.31A12.66,12.66,0,1,0,558.94,590,12.67,12.67,0,0,0,546.29,577.31Z",
    style: {
      fill: "#2e2e76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bab9fac6-f03b-43d4-8386-64cfd87a5647",
    "data-name": "Finger"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.81,734.81s11.59-23.17,58.83-22.28c0,0,58.83-1.78,78.44,21.39L837.32,766H698.27Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.17,790.47H843.53l-48.8-122S801,551.36,752.9,547.88c0,0-10.06-9.76-28.19-5.58,0,0-15-13.94-30.36-7l-40-120a7.76,7.76,0,0,0-13.81-1.89c-6,9.14-10.53,26.36.52,57.14,0,0,.16,30.73,12.27,70.36l5.47,62-16-28.58s2.18-33.26-20.93-39.5a8.67,8.67,0,0,0-11,7.82l-2.44,41a28.88,28.88,0,0,0,4.12,16.69c11.63,19.24,44.24,69.8,87.38,108.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.53,793H713.17a2.5,2.5,0,0,1-2.47-2.1l-13.1-80.69c-42.89-38.7-75.24-88.72-87.19-108.5a31.24,31.24,0,0,1-4.47-18.13l2.44-41a11.17,11.17,0,0,1,14.1-10.09c23.07,6.24,23,36,22.82,41.32l10,17.81-4.42-50.19c-11.23-36.86-12.22-66.46-12.3-70.39-11.28-31.69-6.3-49.55-.12-59a10.11,10.11,0,0,1,9.82-4.48,10.26,10.26,0,0,1,8.45,7l39.17,117.54c13.51-4.41,25.93,4.59,29.51,7.54,16-3.22,25.87,3.67,28.53,5.87,47.86,4.73,43.8,112.76,43.32,122.6l48.6,121.48a2.5,2.5,0,0,1-2.32,3.43ZM715.3,788H839.83L792.41,669.41a2.44,2.44,0,0,1-.18-1.07c.06-1.14,5.61-114.7-39.51-118a2.47,2.47,0,0,1-1.55-.7c-.37-.35-9.43-8.73-25.89-4.93a2.52,2.52,0,0,1-2.27-.61c-.13-.12-14-12.71-27.63-6.52a2.5,2.5,0,0,1-3.4-1.49l-40-120a5.22,5.22,0,0,0-4.36-3.58,5.09,5.09,0,0,0-5,2.27c-5.58,8.5-10,24.93.78,54.92a2.39,2.39,0,0,1,.15.83c0,.31.31,30.87,12.16,69.65a1.71,1.71,0,0,1,.1.51l5.47,62a2.5,2.5,0,0,1-4.67,1.44l-16-28.58a2.55,2.55,0,0,1-.31-1.38c0-.32,1.76-31.29-19.1-36.93a6.19,6.19,0,0,0-5.26,1,6.08,6.08,0,0,0-2.54,4.61l-2.44,41a26.32,26.32,0,0,0,3.76,15.25c11.9,19.69,44.19,69.62,86.91,107.95a2.48,2.48,0,0,1,.79,1.46Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.37,734.37s10.19,29.8,69.08,33.43c57.94,3.56,69.08-33.43,69.08-33.43L860.94,803H695.15Z",
    style: {
      fill: "#2563f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.36,564.39a2.5,2.5,0,0,1-2.41-1.84l-5.35-19.61a2.5,2.5,0,1,1,4.82-1.32l5.35,19.61A2.5,2.5,0,0,1,731,564.3,2.61,2.61,0,0,1,730.36,564.39Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.1,568a2.51,2.51,0,0,1-2.41-1.84l-4.46-16a2.5,2.5,0,0,1,4.82-1.34l4.46,16a2.49,2.49,0,0,1-1.74,3.07A2.65,2.65,0,0,1,757.1,568Z",
    style: {
      fill: "#2e2e76"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.83,559.93a2.52,2.52,0,0,1-2.37-1.7L691,533a2.5,2.5,0,1,1,4.74-1.59l8.46,25.19a2.49,2.49,0,0,1-1.57,3.16A2.44,2.44,0,0,1,701.83,559.93Z",
    style: {
      fill: "#2e2e76"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "be2793de-24d4-4aee-ada4-b9e7d3f3feea",
    "data-name": "Underline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.12,
    y: 800.63,
    width: 900,
    height: 5,
    style: {
      fill: "#2e2e76"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgot);
export default __webpack_public_path__ + "static/media/forgot.d99be41ba5664746191bce43e0e1cded.svg";
export { ForwardRef as ReactComponent };